/**
 * 仓绫类的配置
 * @type {number}
 */
const BANKING_ID = 1;

const USER_BANK_1_LEVEL =1;
const USER_BANK_2_LEVEL =2;
const USER_BANK_3_LEVEL =3;
const USER_BANK_4_LEVEL =4;

const USER_LEVEL_NAME ={
    [BANKING_ID]:{
        [USER_BANK_1_LEVEL]:"财富新人",
        [USER_BANK_2_LEVEL]:"财富达人",
        [USER_BANK_3_LEVEL]:"财富精英",
        [USER_BANK_4_LEVEL]:"私人银行家",
    }
}
const COURSE_LEVEL_NAME ={
    [BANKING_ID]:{
        [USER_BANK_1_LEVEL]:"初级",
        [USER_BANK_2_LEVEL]:"中级",
        [USER_BANK_3_LEVEL]:"中级",
        [USER_BANK_4_LEVEL]:"高级",
    }

}

export default {
    BANKING_ID,
    USER_LEVEL_NAME,
    COURSE_LEVEL_NAME
}



// WEBPACK FOOTER //
// ./src/lib/const.js